import { urlTuition } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyCreateTuition, IBodyUpdateTuition, IQueryGetTuitions, ITuition } from '~/utils/interface/tuition';

export const tuitionApi = {
  getListTuitions(params: IQueryGetTuitions) {
    const url = `${urlTuition.getList}`;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITuition[]>>>(url, { params });
  },

  createTuition(body: IBodyCreateTuition) {
    const url = `${urlTuition.create}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateTuition(tuitionId: string, body: IBodyUpdateTuition) {
    const url = `${urlTuition.update(tuitionId)}`;
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getTuitionById(tuitionId: string) {
    const url = `${urlTuition.getById(tuitionId)}`;
    return axiosClient.get<IBaseResponse<ITuition>>(url);
  },

  deleteTuitionById(tuitionId: string) {
    const url = `${urlTuition.deleteById(tuitionId)}`;
    return axiosClient.delete<IBaseResponse>(url);
  },
};
